import { Link, useLocation } from "react-router-dom";
import { LOGO } from "../constants";
import { useTheme } from "../ThemeContext";
import { FOOTER_COPY, FOOTER_GROUPS } from "./nav/navConfig";

const TikTokIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V9.05a8.28 8.28 0 004.84 1.54V7.15a4.85 4.85 0 01-1.07-.46z"/>
  </svg>
);
const XIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);
const InstagramIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);
const PinterestIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
  </svg>
);

const socials = [
  { label: "TikTok",    href: "https://www.tiktok.com/@atenodesign?lang=en",       icon: <TikTokIcon /> },
  { label: "X",         href: "https://x.com/atenodesign?s=21",              icon: <XIcon /> },
  { label: "Instagram", href: "https://www.instagram.com/ateno.design/",     icon: <InstagramIcon /> },
  { label: "Pinterest", href: "https://www.pinterest.com/atenodesign/",      icon: <PinterestIcon /> },
];

const FOOTER_NOTES = [
  ["1", "Capture results, reconstruction quality, generated outputs, latency, acceleration, and overall performance vary by device, browser, network connection, capture quality, scene complexity, workload, and service availability."],
  ["2", "Descriptions of Ateno Studio, AX, integrations, research, access, support, pricing, and regional availability may change as products move through beta, release, review, and partner integrations."],
  ["3", "Images, videos, animations, interface previews, code snippets, hardware renders, board compositions, and demo metrics are illustrative and may not represent every environment, configuration, or final production result."],
  ["5", "Use of third-party platforms, app stores, XR runtimes, commerce systems, file formats, and partner integrations may require separate approvals, compatible devices, rights to uploaded content, and user permissions."],
];

const PAGE_NOTES = {
  "/": ["1", "2", "3", "5"],
  "/software": ["1", "2", "3", "5"],
  "/ax": ["2", "3"],
};

/* Tiny SVG icons for the theme switcher */
const SunIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);
const MoonIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
  </svg>
);
const MonitorIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
  </svg>
);

export default function Footer() {
  const { mode, setMode } = useTheme();
  const { pathname } = useLocation();
  const noteNumbers = PAGE_NOTES[pathname.replace(/\/$/, "") || "/"] || [];
  const notes = FOOTER_NOTES.filter(([number]) => noteNumbers.includes(number));

  return (
    <footer className="footer">
      <div className="container">
        {notes.length > 0 && (
        <>
        <div className="footer-notes" aria-label="Product notes">
          {notes.map(([number, text]) => (
            <p key={number}>
              <sup>{number}</sup>
              {text}
            </p>
          ))}
        </div>
        <div className="divider footer-notes-divider" />
        </>
        )}
        <div className="footer-grid grid-footer" style={{marginBottom:44}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
              <img src={LOGO} alt="Ateno" style={{height:32,width:32,objectFit:"contain",filter:"var(--logo-filter)"}}/>
              <span style={{fontSize:16,fontWeight:600,color:"var(--text-primary)",letterSpacing:"-.02em"}}>Ateno</span>
            </div>
            <p style={{fontSize:13,color:"var(--text-secondary)",lineHeight:1.65,maxWidth:300}}>
              {FOOTER_COPY}
            </p>
            <div style={{display:"flex",gap:10,flexWrap:"wrap",marginTop:18}}>
              <Link to="/#contact" className="btn btn-sm btn-white">Contact Team</Link>
            </div>
            <p style={{fontSize:12,color:"var(--text-faint)",marginTop:18}}>© 2026 Ateno Inc. · Registered corporation</p>
          </div>
          {FOOTER_GROUPS.map(col => (
            <div key={col.title}>
              <div className="footer-col-title">{col.title}</div>
              {col.items.map(([label, path]) => {
                const external = typeof path === "string" && /^(https?:|mailto:|tel:)/.test(path);

                return external ? (
                  <a
                    key={label}
                    className="footer-link"
                    style={{ textDecoration: "none" }}
                    href={path}
                    target={path.startsWith("http") ? "_blank" : undefined}
                    rel={path.startsWith("http") ? "noopener noreferrer" : undefined}
                  >
                    {label}
                  </a>
                ) : (
                  <Link key={label} className="footer-link" style={{ textDecoration: "none" }} to={path}>
                    {label}
                  </Link>
                );
              })}
            </div>
          ))}
        </div>
        <div className="divider" style={{marginBottom:22}}/>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12}}>
          <p style={{fontSize:12,color:"var(--text-faint)",margin:0,display:"flex",alignItems:"center",gap:0,flexWrap:"wrap",lineHeight:1.8}}>
            <a href="mailto:info@ateno.co" style={{color:"var(--text-muted)",textDecoration:"none"}}>info@ateno.co</a>
            <span style={{margin:"0 10px",opacity:.3}}>·</span>
            <a href="tel:+13022481852" style={{color:"var(--text-muted)",textDecoration:"none"}}>+1 (302) 248‑1852</a>
            <span style={{margin:"0 10px",opacity:.3}}>·</span>
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                title={s.label}
                style={{color:"var(--text-muted)",display:"inline-flex",alignItems:"center",marginRight:10,transition:"color .15s",textDecoration:"none"}}
                onMouseEnter={e => e.currentTarget.style.color="var(--text-primary)"}
                onMouseLeave={e => e.currentTarget.style.color="var(--text-muted)"}
              >{s.icon}</a>
            ))}
          </p>
          <div className="theme-switcher">
            <button type="button" onClick={() => setMode("light")} className={mode === "light" ? "active" : ""} title="Light" aria-pressed={mode === "light"} aria-label="Switch to light theme"><SunIcon /></button>
            <button type="button" onClick={() => setMode("dark")} className={mode === "dark" ? "active" : ""} title="Dark" aria-pressed={mode === "dark"} aria-label="Switch to dark theme"><MoonIcon /></button>
            <button type="button" onClick={() => setMode("auto")} className={mode === "auto" ? "active" : ""} title="Auto" aria-pressed={mode === "auto"} aria-label="Use system theme"><MonitorIcon /></button>
          </div>
        </div>
      </div>
    </footer>
  );
}
